import React from 'react';
import { FaCalendarDays } from 'react-icons/fa6';
import './DateFilter.scss';

interface DateFilterProps {
  startDate: string | null;
  setStartDate: (date: string) => void;
  endDate: string | null;
  setEndDate: (date: string) => void;
}

const DateFilter: React.FC<DateFilterProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  return (
    <div className="date-range-container">
      <FaCalendarDays className="date-icon" />
      <div className="date-inputs">
        <div className="date-input-wrapper">
          <input
            type="date"
            className="date-input"
            value={startDate || ''}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <span className="date-separator">→</span>
        <div className="date-input-wrapper">
          <input
            type="date"
            className="date-input"
            value={endDate || ''}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
